import { Injector, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import firebase from 'firebase/app';
import 'firebase/app-check';
import 'firebase/storage';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import {
	NbThemeModule,
	NbLayoutModule,
	NbToastrModule,
	NbDialogModule,
	NbCardModule,
	NbIconModule,
	NbInputModule,
	NbButtonModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { FormioModule } from '@formio/angular';

import * as Formio from 'formiojs';
import { CustomAudioRecorderComponent } from './@theme/components/custom-audio-recorder/custom-audio-recorder.component';
import { FormComponentComponent } from './form-component/form-component.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { CompletedComponent } from './completed/completed.component';
import { ErrorComponent } from './error/error.component';
import { TrackingComponent } from './tracking/tracking.component';
import { TrackingDetailComponent } from './tracking/tracking-detail/tracking-detail.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha'
import { environment } from '../environments/environment';
import { NgxSpinnerModule } from 'ngx-spinner';
import { registerAudioRecorderComponent } from './@theme/components/custom-audio-recorder/custom-audio-recorder-formio';

@NgModule({
	declarations: [
		AppComponent,
		FormComponentComponent,
		NotFoundComponent,
		CompletedComponent,
		ErrorComponent,
		CustomAudioRecorderComponent,
		TrackingComponent,
		TrackingDetailComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		NoopAnimationsModule,
		NbThemeModule.forRoot({ name: 'default' }),
		NbLayoutModule,
		NbEvaIconsModule,
		NbCardModule,
		NbIconModule,
		NbInputModule,
		NbButtonModule,
		FormioModule,
		NbToastrModule.forRoot(),
		NbDialogModule.forRoot(),
		RecaptchaV3Module,
		NgxSpinnerModule
	],
	providers: [
		{
			provide: RECAPTCHA_V3_SITE_KEY,
			useValue: environment.recaptcha.siteKey,
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {

	constructor(
		private readonly injector: Injector
	) {
		registerAudioRecorderComponent(this.injector);
		this.initializeFirebase();
	}

	/**
	 * Initializes Firebase app and activates App Check
	 * with reCAPTCHA V3 as attestation provider.
	 */
	private initializeFirebase(): void {
		const { firebaseConfig, recaptcha } = environment;
		firebase.initializeApp(firebaseConfig);
		firebase.appCheck().activate(recaptcha.siteKey, true);
	}

}

